// extracted by mini-css-extract-plugin
module.exports = {"registerLink":"styles_registerLink__2RhZt"};